<template>
  <div v-if="$attrs.class && $attrs.class.includes('search-dashboard')" class="input-bistro-wrapper">
    <input
      v-model="value"
      :type="type"
      :placeholder="placeholder"
      :maxlength="maxlength"
      class="inputFilter"
      v-bind="$attrs"
    />
    <span
      v-if="$attrs.class.includes('search-icon')"
      class="icon-Bistro-_Search input-icon left"
    ></span>
    <span
      v-else
      class="icon-Bistro-_Close input-icon left"
      @click="clearInput"
      id="btnCloseSearch"
    ></span>
  </div>
  
  <input v-else v-model="value" :type="type" :placeholder="placeholder" :maxlength="maxlength" class="search" :class="{ 'hide-search': value }"/>
</template>

<script>
export default {
  name: "InputBistro",
  props: {
    type: {
      type: String,
      default: "text",
      validator: function (value) {
        return ["text", "email", "number", "search"].includes(value);
      },
    },
    placeholder: {
      type: String,
    },
    initialValue: {
      type: String,
      default: "",
    },
    // Prop maxlength para limitar caracteres (ej: comentario de comanda)
    maxlength: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      value: null
    };
  },
  methods: {
    clearInput() {
      this.value = '';
      this.$emit('handleChange', '');
    }
  },
  mounted() {
    this.value = this.initialValue;
  },
  watch: {
    value() {
      this.$emit("handleChange", this.value);
    }
  }
};
</script>

<style lang="scss">
input {
  outline: none;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 3px;
  color: $darkColorFont;
  height: 46px;
  width: 100%;
  max-width: 400px;
  padding: 0 10px;
  margin: 0;

  &[type="search"] {
    background-image: url(@assets/icon-search.svg);
    background-repeat: no-repeat;
    background-position: 12px center;
    padding-left: 40px;
  }

  &.hide-search[type="search"] {
    background-image: none;
  }

  &[type="text"] {
    color: black;
  }

  &:focus {
    border-color: $primaryColor;
  }
}
.input-bistro-wrapper {
  position: relative;
  width: 100%;
}
.inputFilter {
  padding-left: 1.2rem !important;
  margin-bottom: 0.2rem !important;
}
.input-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
}
.input-icon.left {
  left: 18px;
  margin-right: 6px;
}
.icon-Bistro-_Search{
  color: $primaryColor;
}
.icon-Bistro-_Close{
  color: $solidRedHover;
  cursor: pointer;
}
</style>